export const BANKS_LIST_KEY = 'BANKS_LIST';
export const BANKS_ONE_KEY = 'BANKS_ONE_KEY';
